import styled from "styled-components";
import { StyledLabelForConfirm } from "../../../components/organisms/Modal/Modal.styles";

export const CloseModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  color: var(--DARK-GREY, #0e0e2c);
  font-size: 14px;
  line-height: 22px;
`;

export const IntroText = styled.p`
  margin: 0;
  color: var(--ASH, #676879);
`;

export const LoadingRow = styled.div`
  align-items: center;
  color: var(--ASH, #676879);
  display: flex;
  gap: 10px;
  padding: 8px 0;
`;

export const OrderList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const OrderRow = styled.div`
  background: var(--MIST, #f7f8f9);
  border: 1px solid var(--PEARL, #ecf1f4);
  border-radius: 6px;
  padding: 12px;
`;

export const OrderRowHeader = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: space-between;
`;

export const OrderName = styled.span`
  font-weight: 600;
`;

const statusPillColors = {
  ready: { bg: "#e8f5ee", color: "#1a7f4b", border: "#b8e0c8" },
  warning: { bg: "#fff8e6", color: "#9a6700", border: "#f5d98c" },
  blocked: { bg: "#fdecef", color: "#cf324a", border: "#f5b8c4" },
};

export const StatusPill = styled.span`
  background: ${({ $tone }) => statusPillColors[$tone].bg};
  border: 1px solid ${({ $tone }) => statusPillColors[$tone].border};
  border-radius: 999px;
  color: ${({ $tone }) => statusPillColors[$tone].color};
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  padding: 4px 10px;
  white-space: nowrap;
`;

export const MessageList = styled.ul`
  list-style: none;
  margin: 10px 0 0;
  padding: 0;
`;

export const MessageLine = styled.li`
  border-left: 3px solid ${({ $variant }) => ($variant === "blocker" ? "#cf324a" : "#e6a817")};
  color: var(--DARK-GREY, #0e0e2c);
  font-size: 13px;
  line-height: 20px;
  margin-top: 6px;
  padding-left: 10px;
`;

export const BlockerBanner = styled.div`
  background: #fdecef;
  border: 1px solid #f5b8c4;
  border-radius: 6px;
  color: #cf324a;
  font-size: 13px;
  line-height: 20px;
  padding: 10px 12px;
`;

export const AcknowledgeBox = styled(StyledLabelForConfirm)`
  align-items: flex-start;
  background: #fff8e6;
  border: 1px solid #f5d98c;
  color: var(--DARK-GREY, #0e0e2c);
  cursor: pointer;
  margin-top: 0;

  input {
    flex-shrink: 0;
    margin-top: 3px;
  }
`;

export const NameChipList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 120px;
  overflow-y: auto;
`;

export const NameChip = styled.span`
  background: var(--MIST, #f7f8f9);
  border: 1px solid var(--PEARL, #ecf1f4);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  padding: 2px 10px;
`;

export const HintText = styled.p`
  margin: 0;
  color: var(--ASH, #676879);
  font-size: 13px;
  line-height: 20px;
`;

export const FieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
